import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";
import EmailModal from "../../../common/email/emailmodal.component.jsx";

class EmailEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            text: this.props.text || null,
            icon: this.props.icon || null,
            iconClassName: this.props.iconClassName || '',
            modal: '',
        }
        this.openEmail = this.openEmail.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    openEmail(event) {
        event.preventDefault()
        this.setState({
            modal: <EmailModal
                onClose={this.handleCloseModal}
                emailId={this.state.object.id}
            />
        })
    }

    render() {
        return <div className={"row " + this.state.className}>
            {this.state.modal}
            <div className="col-12">
                <p className={'mb-0'}>
                    {this.state.text}
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-4'}>
                    <h2 className={"m-0 " + this.state.iconClassName}>
                        <Icon value={this.state.icon}/>
                    </h2>
                </div>
                <div className={'mr-4'}>
                    <p className={"m-0"}>
                        <strong>{this.state.object.attributes.subject}</strong>
                    </p>
                    <p className={"m-0"}>
                        <FormattedMessage
                            id="quote.analytics.events.email.to"
                            defaultMessage="To: {email}"
                            values={{
                                email: this.state.object.attributes.toEmail
                            }}
                        />
                    </p>

                </div>
                <div className={'mr-3'}>
                    <p className={"m-0"}>
                        <button className={'btn btn-sm btn-outline-primary'} onClick={this.openEmail}>
                            <Icon value={"eye"} className={'mr-1'}/>
                            <FormattedMessage
                                id="quote.analytics.events.email.preview_btn"
                                defaultMessage="Preview"
                            />
                        </button>
                    </p>
                </div>
            </div>
        </div>
    }

}

export default EmailEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/emailevent.component.jsx